import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, Optional, Inject } from '@angular/core';
import { GridOptions } from '@ag-grid-community/all-modules';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PershingTranslationService } from '@pershing/pershing-core';
import { AccountsResult } from '../../models/accounts-result.model';
import { EDeliveryService } from '../../services/edelivery.service';
import { WarningService } from '../../services/warning.service';
import { AgreementService } from '../../services/agreement.service';
import { Email } from '../../models/e-mail.model';
import { Warning } from '../../models/warning.model';
import { EMailService } from '../../services/email.service';
import { Observable, BehaviorSubject, Subscription } from 'rxjs';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { EdeliveryLabels } from '../../i18n/edelivery-labels';
import { ConfirmationComponent } from '../confirmationDialog/confirmation.component';
import { PershingError } from '@pershing/pershing-core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'quick-enroll',
  templateUrl: './quick-enroll.component.html',
  styleUrls: ['./quick-enroll.component.css'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class QuickEnrollComponent implements OnInit, OnDestroy {

  preferencesResponse: Observable<AccountsResult>;
  gridOptions: GridOptions;
  response: any;
  trackingList = [];
  listToBeSubmitted = [];
  allDocumentNames: any;
  emailAddresses: any;
  disabled = true; // Save button flag
  userFromMyClientView: boolean;
  disableFromDocs: boolean;
  disabledFromEmail: boolean;
  disableEmail = true;
  loading: boolean = false;
  userEmails: Email[] = [];
  routeSubscription: Subscription;

  selectedEmail: string = '';
  selectAllChecked = false;
  proxyChecked = false;
  prospectusChecked = false;
  displayProspectus = false;
  warning: Warning;
  hide = true;
  disableSelect = new FormControl(false);
  private subscription: Subscription;
  private confirmationSubscription: Subscription;
  private _error: BehaviorSubject<PershingError>;

  notifIndex: number;
  taxIndex: number;

  displayQPRDisclaimer: boolean;
  displayCommunicationTypesDisclaimer: boolean;
  updatePreferencesInProgressFlag: boolean = false;

  // Labels
  emailAddressInfo: any = EdeliveryLabels.EMAIL_ADDRESS_INFO;
  communicationTypes: any = EdeliveryLabels.COMMUNICATION_TYPES;
  QPRDisclaimer: any = EdeliveryLabels.QPR_DISCLAIMER;
  reminder: any = EdeliveryLabels.REMINDER;
  reminderLabel: any = EdeliveryLabels.REMINDER_LABEL;
  save: any = EdeliveryLabels.SAVE;
  saveFirst: any = EdeliveryLabels.SAVE_FIRST;
  saveSecond: any = EdeliveryLabels.SAVE_SECOND;
  electronicAgreement: any = EdeliveryLabels.ELECTRONIC_AGREEMENT;
  saveThird: any = EdeliveryLabels.SAVE_THIRD;
  proxyInfo = EdeliveryLabels.PROXY_INFO;
  edeliveryPreferencesTitle: any = EdeliveryLabels.EDELIVERY_PREFERENCES_TITLE;
  headerDescription: any = EdeliveryLabels.HEADER_DESCRIPTION;
  headerDescription2: any = EdeliveryLabels.HEADER_DESCRIPTION_PART2;
  headerDescription3: any = EdeliveryLabels.HEADER_DESCRIPTION_PART3;
  selectAllLabel: any = EdeliveryLabels.SELECT_ALL;
  qprLabel: any = EdeliveryLabels.QPR;
  prospectusLabel: any = EdeliveryLabels.PROSPECTUS;
  proxyLabel: any = EdeliveryLabels.PROXY;
  applicableLabel: any = EdeliveryLabels.APPLICABLE_ACCOUNTS;
  selectEmailDesc: any = EdeliveryLabels.SELECT_EMAIL_DESC;
  saveLabel = EdeliveryLabels.SAVE;
  cancelLabel = EdeliveryLabels.CANCEL;


  constructor(private eDeliveryService: EDeliveryService, private agreementService: AgreementService, public dialog: MatDialog, private translate: PershingTranslationService,
              private emailService: EMailService, private warningService: WarningService, private dialogRef: MatDialogRef<QuickEnrollComponent>,
              private router: Router, private route: ActivatedRoute, @Optional() @Inject('AppSettings') appSettings: any) {
    this.userEmails = this.emailService.getUserEmails();
    if (this.eDeliveryService.backButtonClicked && this.eDeliveryService.quickEnrollUpdatedEmail !== '') {
      this.selectedEmail = this.eDeliveryService.quickEnrollUpdatedEmail;
    } else {
      this.selectedEmail = this.userEmails[0].emailAddress;
    }
    console.log('selected email in ngOnInit: ', this.selectedEmail);
    if (this.translate) {
      this.translate.addTranslationFolder('@pershing/edc-edelivery', 'node_modules/@pershing/edc-edelivery/lib');
    }
    if (appSettings.ibdConfigMap) {
      this.userFromMyClientView = !!appSettings.isAdvisor ? appSettings.isAdvisor : false;
    }
  }

  ngOnInit() {
    this.emailAddresses = this.emailService.getUserEmails();
    this.warning = new Warning('');
    this.preferencesResponse = this.eDeliveryService.preferencesResponse$;
    this.subscription = this.preferencesResponse.subscribe(response => {
      if (response.accounts && !this.eDeliveryService.prefPopupAlreadyTriggered) {
        this.response = response;
        console.log('quick enroll response: ', this.response);

        this.eDeliveryService.findQuickEnrolled();
        this.eDeliveryService.createTrackingList();
        // Disable or enable save button
        for (let i = 0; i < this.eDeliveryService.currentSettings.length; i++) {
          if (this.eDeliveryService.currentSettings[i] !== this.eDeliveryService.previousSettings[i]) {
            this.disabled = false;
            this.disableFromDocs = false;
            break;
          } else {
            // this.disabled = true;
            this.disableFromDocs = true;
          }
        }
        if (this.eDeliveryService.displayProspectusQuickEnroll === true) {
          this.displayProspectus = true;
        }
        this.checkIfEmailsAreTheSame();
        this.areDocumentNamesChecked();
        this.isProspectusChecked();
        this.isProxyChecked();
        if (this.eDeliveryService.backButtonClicked) {
          // Reset final list of accounts because when clicking save again it'll get re-populated
          this.eDeliveryService.finalListOfAccounts = [];

          // Call tracklist of docs with the current preferences settings.
          for (let j = 0; j < this.eDeliveryService.currentSettings.length; j++) {
            let myEvent;
            let index = j;
            // Need to change order here since the displayed version of tax and notif are reversed.
            if (j === 3) {
              index = 4;
            } else if (j === 4) {
              index = 3;
            }
            myEvent = { checked: this.eDeliveryService.currentSettings[j] };
            this.trackListOfDocs(myEvent, index);
          }
          this.isSelectAllChecked(this.eDeliveryService.currentSettings);
        } else {
          this.isSelectAllChecked();
        }
        this.isEmailDisabled();

        this.changeSaveButtonState();

        if (this.eDeliveryService.isQuickEnrollDisplayed) {
          let myEvent = { checked: true };
          this.selectAll(myEvent);
          this.eDeliveryService.prefPopupAlreadyTriggered = true;
          this.eDeliveryService.isQuickEnrollDisplayed = false;
        }
        this.displayQPRDisclaimer = this.eDeliveryService.displayQPRDisclaimer;
        this.displayCommunicationTypesDisclaimer = this.eDeliveryService.displayCommunicationTypesDisclaimer;
      }
    });
    this.eDeliveryService.retrievePreferences();
    this.warningService.proxyWarning$.subscribe(warning => {
      if (warning) {
        console.log('warning inside of grid cell: ', warning);
        this.warning.warningMessage = warning.warningMessage;
      }
    });
    this.routeSubscription = this.route.queryParamMap.subscribe(routeResponse => {
      if (routeResponse) {
        let myParamKeys = routeResponse.keys;
        let myQueryParams = {};
        myParamKeys.forEach(element => {
          if (element === 'showPopup') {
            myQueryParams[element] = false;
          } else {
            myQueryParams[element] = routeResponse.get(element);
          }
        });
        this.router.navigate(
          [],
          {
            relativeTo: this.route,
            queryParams: myQueryParams
          });
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.confirmationSubscription) {
      this.confirmationSubscription.unsubscribe();
    }
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
    this.eDeliveryService.prefPopupAlreadyTriggered = false;
  }

  checkIfEmailsAreTheSame() {
    // for (let i = 0; i < this.response.accounts.length; i++) {
    //   if (this.response.accounts[i].edelElgible) {
    //     break;
    //   }
    //   this.disabled = true;
    //   return;
    // }
    let enableSaveButton = false;
    for (let i = 0; i < this.response.accounts.length; i++) {
      if (this.response.accounts[i].edelElgible) {
        enableSaveButton = true;
      }
    }
    if (!enableSaveButton) {
      this.disabled = true;
      return;
    }
    if (this.eDeliveryService.currentSettings[5] !== this.eDeliveryService.previousSettings[5] ||
      this.eDeliveryService.currentSettings[6] !== this.eDeliveryService.previousSettings[6]) {
      this.disabled = false;
      this.disabledFromEmail = false;
      return;
    }
    let noChange = true;
    for (let i = 0; i < this.response.accounts.length; i++) {
      if (this.response.accounts[i].externalEmailAddr !== null && this.response.accounts[i].externalEmailAddr !== this.selectedEmail) {
        this.disabled = false;
        this.disabledFromEmail = false;
        noChange = false;
        this.eDeliveryService.quickEnrollUpdatedEmail = this.selectedEmail;
        // break;
      }
    }
    if (noChange) {
      // this.disabled = true;
      this.disabledFromEmail = true;
    }
    // Change email in tracking list since it's what is used to compare emails when saving preferences
    for (let i = 0; i < this.eDeliveryService.trackingList.length; i++) {
      this.eDeliveryService.trackingList[i].externalEmailAddr = this.selectedEmail;
    }
    this.changeSaveButtonState();
  }

  selectAll($event) {
    for (let i = 0; i < this.allDocumentNames.length; i++) {
      this.trackListOfDocs($event, i);
    }
    // Required since trackListOfDocs sets disabled = true if all docs types are the same as preiovusly.
    this.checkIfEmailsAreTheSame();
    // this.changeSaveButtonState();
  }

  trackListOfDocs($event, index): void {
    let tempIndex = index;

    // Switch index for Tax and Notifications
    let taxIndex = this.taxIndex;
    if (index === taxIndex) {
      index = index + 1;
    } else if (index === taxIndex + 1) {
      index = index - 1;
    }

    this.warning.warningMessage = '';
    if ($event.checked) {
      if (index === 5 || index === 6) {
        this.disableEmail = false;
        if (index === 5) {
          this.proxyChecked = true;
        } else {
          this.prospectusChecked = true;
        }
      }
      // this.proxyChecked = true;
      this.eDeliveryService.currentSettings[index] = true;
      this.allDocumentNames[tempIndex].checked = true;
      this.isSelectAllChecked(this.eDeliveryService.currentSettings);
    } else {
      if (index === 5 || index === 6) {
        if (index === 6) {
          this.prospectusChecked = false;
          if (!this.proxyChecked) {
            this.disableEmail = true;
          }
        } else {
          this.proxyChecked = false;
          if (!this.prospectusChecked) {
            this.disableEmail = true;
          }
        }
      }
      this.eDeliveryService.currentSettings[index] = false;
      this.allDocumentNames[tempIndex].checked = false;
      this.isSelectAllChecked(this.eDeliveryService.currentSettings);
    }
    let didChange = false; // So that we can disable save button when the preferences are set exactly as how they were initially.
    for (let i = 0; i < this.eDeliveryService.currentSettings.length; i++) {
      if (this.eDeliveryService.currentSettings[i] !== this.eDeliveryService.previousSettings[i]) {
        this.disabled = false;
        this.disableFromDocs = false;
        didChange = true;
        break;
      }
    }
    if (!didChange) {
      // this.disabled = true;
      this.disableFromDocs = true;
    }
    // Enable button if even 1 document type is pending
    this.enableSaveBasedOnPending();
    this.changeSaveButtonState();
    // console.log('currentSettings: ', this.eDeliveryService.currentSettings);
    for (let i = 0; i < this.response.accounts.length; i++) {
      let docEligible = this.eDeliveryService.trackingList[i].edeliveryDocuments[index].docEligible;
      if (docEligible && this.eDeliveryService.trackingList[i].edelElgible) {
        let documentPreference = this.eDeliveryService.trackingList[i].edeliveryDocuments[index].preferenceType;
        let docType = this.eDeliveryService.trackingList[i].edeliveryDocuments[index].edocumentType.docType;
        if ($event.checked) { // true
          documentPreference.deliveryPreference = 2;
          documentPreference.preferenceCode = 'ONLINE';
          documentPreference.preferenceCodeMF = 'E';
          if (docType === 6 || docType === 7) {
            this.eDeliveryService.trackingList[i].externalEmailAddr = this.selectedEmail;
          }
        } else { // false / makes sure that an account doesn't get de-enrolled by mistake.
          documentPreference.deliveryPreference = 1;
          documentPreference.preferenceCode = 'PAPER';
          documentPreference.preferenceCodeMF = 'P';
        }
        let value = JSON.parse(JSON.stringify(this.eDeliveryService.trackingList[i]));
        this.eDeliveryService.accountsMap.set(this.eDeliveryService.trackingList[i].accountNumber, value.edeliveryDocuments);
      }
    }
  }

  enableSaveBasedOnPending() {
    for (let i = 0; i < this.response.accounts.length; i++) {
      for (let j = 0; j < this.response.accounts[i].edeliveryDocuments.length; j++) {
        let myDocument = this.response.accounts[i].edeliveryDocuments[j];
        if (myDocument.preferenceType.deliveryPreference === 4) {
          this.disabled = false;
          this.disableFromDocs = false;
        }
      }
    }
    // for (let i = 0; i < this.response.accounts.length; i++) {
    //   if (this.response.accounts[i].edelElgible) {
    //     break;
    //   }
    //   this.disabled = true;
    // }
    let enableSaveButton = false;
    for (let i = 0; i < this.response.accounts.length; i++) {
      if (this.response.accounts[i].edelElgible) {
        enableSaveButton = true;
      }
    }
    if (!enableSaveButton) {
      this.disabled = true;
    }
  }

  changeSaveButtonState() {
    // for (let i = 0; i < this.response.accounts.length; i++) {
    //   if (this.response.accounts[i].edelElgible) {
    //     break;
    //   }
    //   this.disabled = true;
    //   return;
    // }
    let enableSaveButton = false;
    for (let i = 0; i < this.response.accounts.length; i++) {
      if (this.response.accounts[i].edelElgible) {
        enableSaveButton = true;
      }
    }
    if (!enableSaveButton) {
      this.disabled = true;
      return;
    }
    if (this.disableFromDocs && this.disabledFromEmail) {
      this.disabled = true;
    } else {
      this.disabled = false;
    }
  }

  // isChecked(index) {
  //   if (this.eDeliveryService.backButtonClicked === true) {
  //     return this.eDeliveryService.savedSettings[index];
  //   } else {
  //     return this.eDeliveryService.previousSettings[index];
  //   }
  // }

  areDocumentNamesChecked() {
    this.allDocumentNames = [];
    let listOfDocs = this.eDeliveryService.trackingList[0].edeliveryDocuments;
    for (let i = 0; i < listOfDocs.length; i++) {
      let document = {};
      let translatedName = this.findNameAccordingToLabel(listOfDocs[i].edocumentType.docTypeDesc);
      let isDocEligible = false;
      if (this.eDeliveryService.listOfEligibleDocs.has(listOfDocs[i].edocumentType.docTypeDesc)) {
        isDocEligible = true;
      }
      if (this.eDeliveryService.backButtonClicked === true) {
        document = { name: translatedName, checked: this.eDeliveryService.savedSettings[i], docEligible: isDocEligible };
      } else {
        document = { name: translatedName, checked: this.eDeliveryService.previousSettings[i], docEligible: isDocEligible };
      }
      this.allDocumentNames.push(document);
      if (listOfDocs[i].edocumentType.docTypeDesc === 'Notifications') {
        this.notifIndex = this.allDocumentNames.length - 1;
      } else if (listOfDocs[i].edocumentType.docTypeDesc === 'Tax Documents') {
        this.taxIndex = this.allDocumentNames.length - 1;
      }
    }

    // Change order of Tax and Notifications
    let tax = this.allDocumentNames[this.taxIndex];
    this.allDocumentNames[this.taxIndex] = this.allDocumentNames[this.notifIndex];
    this.allDocumentNames[this.notifIndex] = tax;
  }

  findNameAccordingToLabel(name) {
    let documentLabel;
    if (name === 'Statements and Reports') {
      documentLabel = EdeliveryLabels.STATEMENTS;
    } else if (name === 'Trade Confirmations') {
      documentLabel = EdeliveryLabels.TRADE;
    } else if (name === 'Notifications') {
      documentLabel = EdeliveryLabels.NOTIFICATIONS;
    } else if (name === 'Tax Documents') {
      documentLabel = EdeliveryLabels.TAX;
    } else if (name === 'Quarterly Performance Reports') {
      documentLabel = EdeliveryLabels.QPR;
    } else if (name === 'Prospectus') {
      documentLabel = EdeliveryLabels.PROSPECTUS;
    } else if (name === 'Proxy/Shareholder Communications') {
      documentLabel = EdeliveryLabels.PROXY;
    }
    return this.translate.translate.instant(documentLabel);
  }

  isSelectAllChecked(settings?: any) {
    let counter = 0;
    let settingsValue = this.eDeliveryService.previousSettings;
    if (settings) {
      settingsValue = this.eDeliveryService.currentSettings;
    }
    if (settingsValue.length === 0) {
      this.selectAllChecked = false;
      return;
    }
    for (let i = 0; i < settingsValue.length; i++) {
      // console.log('previous settings of ', i , ' :', this.eDeliveryService.previousSettings[i]);
      if (settingsValue[i]) {
        counter++;
      }
    }
    if (counter === settingsValue.length) {
      this.selectAllChecked = true;
      return;
    }
    this.selectAllChecked = false;
  }

  isProspectusChecked() {
    if (this.eDeliveryService.backButtonClicked === true) {
      if (this.eDeliveryService.savedSettings[6] === true && this.eDeliveryService.displayProspectusQuickEnroll) {
        // this.disableEmail = false;
        this.prospectusChecked = true;
        return true;
      } else {
        // this.disableEmail = true;
        this.prospectusChecked = false;
        return false;
      }
    } else {
      if (this.eDeliveryService.previousSettings[6] === true && this.eDeliveryService.displayProspectusQuickEnroll) {
        // this.disableEmail = false;
        this.prospectusChecked = true;
        return true;
      } else {
        // this.disableEmail = true;
        this.prospectusChecked = false;
        return false;
      }
    }
  }

  isProxyChecked() {
    if (this.eDeliveryService.backButtonClicked === true) {
      if (this.eDeliveryService.quickEnrollWarningMessage !== '') {
        this.warning.warningMessage = this.eDeliveryService.quickEnrollWarningMessage;
        // this.eDeliveryService.quickEnrollWarningMessage = '';
        if (this.eDeliveryService.savedSettings[5] === true) {
          this.proxyChecked = true;
          return true;
        } else {
          this.proxyChecked = false;
          return false;
        }
      } else if (this.eDeliveryService.savedSettings[5] === true) {
        this.proxyChecked = true;
        return true;
      } else {
        this.proxyChecked = false;
        return false;
      }
    } else {
      if (this.eDeliveryService.previousSettings[5] === true) {
        this.proxyChecked = true;
        return true;
      } else {
        this.proxyChecked = false;
        return false;
      }
    }
  }

  isEmailDisabled(): boolean {
    if (!this.isProspectusChecked() && !this.isProxyChecked()) {
      this.disableEmail = true;
      return true;
    } else {
      this.disableEmail = false;
      return false;
    }
  }

  addPinToAccountsMap() {
    let enableSaveButton = false;
    for (let i = 0; i < this.response.accounts.length; i++) {
      if (this.response.accounts[i].edelElgible) {
        enableSaveButton = true;
      }
    }
    if (!enableSaveButton) {
      this.disabled = true;
      return;
    }
    this.warning.warningMessage = '';
    this.eDeliveryService.quickEnrollWarningMessage = '';
    this.disabled = false;
    for (let i = 0; i < this.response.accounts.length; i++) {
      let value = JSON.parse(JSON.stringify(this.eDeliveryService.trackingList[i]));
      this.eDeliveryService.accountsMap.set(this.eDeliveryService.trackingList[i].accountNumber, value.edeliveryDocuments);
    }
    this.addAccountsToFinalList();
  }

  addAccountsToFinalList() {
    for (let i = 0; i < this.response.accounts.length; i++) {
      let singleAccount = JSON.parse(JSON.stringify(this.response.accounts[i]));
      let proxyDocument;
      proxyDocument = this.response.accounts[i].edeliveryDocuments[5];
      singleAccount.externalEmailAddr = this.selectedEmail;
      singleAccount.edeliveryDocuments = [];
      // Only add to the account if the user is enrolled to either proxy or prospectus
      if (this.proxyChecked) {
        singleAccount.edeliveryDocuments.push(proxyDocument);
      }
      console.log('single account: ', singleAccount);
      this.checkIfAccountsAlreadyAdded(singleAccount);
      this.eDeliveryService.trackingList[i].externalEmailAddr = this.selectedEmail;
    }
  }

  checkIfAccountsAlreadyAdded(singleAccount) {
    let accountAlreadyAdded = false;
    for (let j = 0; j < this.eDeliveryService.finalListOfAccounts.length; j++) {
      // Only replace account if user decides to change pin again.
      if (this.eDeliveryService.finalListOfAccounts[j].accountNumber === singleAccount.accountNumber) {
        let finalListIndex = this.findProxyIndex(this.eDeliveryService.finalListOfAccounts[j]);
        this.eDeliveryService.finalListOfAccounts[j].externalEmailAddr = this.selectedEmail;
        accountAlreadyAdded = true;
      }
    }
    if (accountAlreadyAdded === false) {
      this.eDeliveryService.finalListOfAccounts.push(singleAccount);
    }
  }

  findProxyIndex(account) {
    for (let j = 0; j < account.edeliveryDocuments.length; j++) {
      if (account.edeliveryDocuments[j].edocumentType.docTypeCd === 'PRXY') {
        return j;
      }
    }
  }

  findProxyInOriginalResponse(accountNumber) {
    for (let i = 0; i < this.response.accounts.length; i++) {
      if (this.response.accounts[i].accountNumber === accountNumber) {
        return this.response.accounts[i].edeliveryDocuments[5];
      }
    }
  }

  findProspectusInOriginalResponse(accountNumber) {
    for (let i = 0; i < this.response.accounts.length; i++) {
      if (this.response.accounts[i].accountNumber === accountNumber) {
        return this.response.accounts[i].edeliveryDocuments[6];
      }
    }
  }

  /** Save the current preferences */
  savePreferences() {
    this.eDeliveryService.checkQuickEnrollPreferences();
    this.addAccountsIfPinOrEmailChanged();
    this.eDeliveryService.quickEnrollUpdatedEmail = this.selectedEmail;
    // If it's in edit mode then check whether savePin returns true
    if (this.eDeliveryService.isUserEnrolling) {
        console.log('user enrolling');
        this.eDeliveryService.goToAgreement();
      } else { // Simply call service.submitPreferences();
        if (!this.updatePreferencesInProgressFlag) {
          this.updatePreferencesInProgressFlag = true;
         } else {
          return;
         }
        this.eDeliveryService.submitPreferences();
        this.confirmationSubscription = this.eDeliveryService.confirmationResponse$.subscribe(confirmResponse => {
          if (confirmResponse.accounts !== undefined) {
            this.eDeliveryService.retrievePreferences();
            // Reset final list and account map so that there is no previous data stored.
            this.eDeliveryService.finalListOfAccounts = [];
            this.eDeliveryService.accountsMap.clear();
            this.dialogRef.close();
            this.dialog.open(ConfirmationComponent, { panelClass: ['modal', 'edel-Confirmation'], width: '40vw', data: confirmResponse });
            this.updatePreferencesInProgressFlag = false;
          }
        },
          error => {
            this.updatePreferencesInProgressFlag = false;
            this.setError(error);
          }
        );
    }
  }

  addAccountsIfPinOrEmailChanged() {
    if (this.prospectusChecked || this.proxyChecked) {
      if (this.eDeliveryService.finalListOfAccounts.length > 0) {
        let listOfEnrolledAccountNumbers = [];
        // This case is for when we are enrolling a document other than proxy and prospectus and want to maintain it the way it is
        for (let j = 0; j < this.eDeliveryService.finalListOfAccounts.length; j++) { // Create list of account numbers
          listOfEnrolledAccountNumbers.push(this.eDeliveryService.finalListOfAccounts[j].accountNumber);
          if (this.eDeliveryService.finalListOfAccounts[j].externalEmailAddr !== this.selectedEmail) {
            this.eDeliveryService.finalListOfAccounts[j].externalEmailAddr = this.selectedEmail;
            let tempProxy = this.findProxyInOriginalResponse(this.eDeliveryService.finalListOfAccounts[j].accountNumber);
            let tempProspectus = this.findProspectusInOriginalResponse(this.eDeliveryService.finalListOfAccounts[j].accountNumber);
            // Push proxy or prospectus if one, the other or both are not enrolled
            if (tempProxy.preferenceType.deliveryPreference !== 1 && this.proxyChecked) {
              this.eDeliveryService.finalListOfAccounts[j].edeliveryDocuments.push(tempProxy);
            }
            if (tempProspectus.preferenceType.deliveryPreference !== 1 && this.prospectusChecked && tempProspectus.docEligible) {
              this.eDeliveryService.finalListOfAccounts[j].edeliveryDocuments.push(tempProspectus);
            }
          }
        }
        // This loop adds proxy or prospectus to every account that wasn't recently enrolled or when email or pin were changed
        for (let i = 0; i < this.response.accounts.length; i++) {
          let singleAccount = JSON.parse(JSON.stringify(this.response.accounts[i]));
          let proxyDocument;
          let prospectusDocument;
          proxyDocument = this.response.accounts[i].edeliveryDocuments[5];
          prospectusDocument = this.response.accounts[i].edeliveryDocuments[6];
          if (listOfEnrolledAccountNumbers.indexOf(singleAccount.accountNumber) <= -1) {
            if (singleAccount.externalEmailAddr !== this.selectedEmail) {
              singleAccount.externalEmailAddr = this.selectedEmail;
              singleAccount.edeliveryDocuments = [];
              // Only add to the account if the user is enrolled to either proxy or prospectus
              if (this.proxyChecked) {
                singleAccount.edeliveryDocuments.push(proxyDocument);
              }
              if (prospectusDocument.docEligible && this.prospectusChecked) {
                singleAccount.edeliveryDocuments.push(prospectusDocument);
              }
              this.eDeliveryService.finalListOfAccounts.push(singleAccount);
            }
          } else {
            if (singleAccount.externalEmailAddr !== this.selectedEmail) {
              if (this.proxyChecked) {
                this.checkIfDocumentExists(proxyDocument, singleAccount.accountNumber, 'PRXY');
              }
              if (prospectusDocument.docEligible && this.prospectusChecked) {
                this.checkIfDocumentExists(prospectusDocument, singleAccount.accountNumber, 'PROS');
              }
            }
          }
          this.eDeliveryService.trackingList[i].externalEmailAddr = this.selectedEmail;
        }
      } else {
        for (let i = 0; i < this.response.accounts.length; i++) {
          let singleAccount = JSON.parse(JSON.stringify(this.response.accounts[i]));
          if (singleAccount.externalEmailAddr !== this.selectedEmail) {
            let proxyDocument;
            let prospectusDocument;
            proxyDocument = this.response.accounts[i].edeliveryDocuments[5];
            prospectusDocument = this.response.accounts[i].edeliveryDocuments[6];
            singleAccount.externalEmailAddr = this.selectedEmail;
            singleAccount.edeliveryDocuments = [];
            // Only add to the account if the user is enrolled to either proxy or prospectus
            if (this.proxyChecked) {
              singleAccount.edeliveryDocuments.push(proxyDocument);
            }
            if (prospectusDocument.docEligible && this.prospectusChecked) {
              singleAccount.edeliveryDocuments.push(prospectusDocument);
            }
            console.log('single account: ', singleAccount);
            this.eDeliveryService.finalListOfAccounts.push(singleAccount);

            // Change the external email of every account in the tracking list for it to reflect on the grid.
            this.eDeliveryService.trackingList[i].externalEmailAddr = this.selectedEmail;
          }
        }
      }
    }
    // Else, Save button should have been disabled
  }

  checkIfDocumentExists(document, singleAccountNumber, checkingTypeName) {
    for (let i = 0; i < this.eDeliveryService.finalListOfAccounts.length; i++) {
      let account = this.eDeliveryService.finalListOfAccounts[i];
      if (account.accountNumber === singleAccountNumber) {
        let itExists = false;
        for (let k = 0; k < account.edeliveryDocuments.length; k++) {
          if (checkingTypeName === account.edeliveryDocuments[k].edocumentType.docTypeCd) {
            itExists = true;
          }
        }
        if (!itExists) {
          account.edeliveryDocuments.push(document);
        }
      }
    }
  }

  goToAgreement() {
    this.agreementService.enableBackToEnrollment = true;
    this.eDeliveryService.quickEnrollUpdatedEmail = this.selectedEmail;
    this.eDeliveryService.quickEnrollWarningMessage = this.warning.warningMessage;
    this.eDeliveryService.goToAgreement();
  }

  superscript1Available(index) {
    if (index >= 2 && index <= 5) {
      return true;
    }
  }

  superscript2Available(docName) {
    if (docName === 'Quarterly Performance Reports') {
      return true;
    }
  }

  close() {
    this.dialogRef.close();
  }

  setError(errorMessage: string, errorCode?: string): void {
    this._error.next(new PershingError(errorMessage, 'confirmationSubscription', errorCode));
  }
}
